import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Validate Firebase configuration
const missingConfig = [];
if (!firebaseConfig.apiKey) missingConfig.push('REACT_APP_FIREBASE_API_KEY');
if (!firebaseConfig.authDomain) missingConfig.push('REACT_APP_FIREBASE_AUTH_DOMAIN');
if (!firebaseConfig.projectId) missingConfig.push('REACT_APP_FIREBASE_PROJECT_ID');
if (!firebaseConfig.storageBucket) missingConfig.push('REACT_APP_FIREBASE_STORAGE_BUCKET');
if (!firebaseConfig.messagingSenderId) missingConfig.push('REACT_APP_FIREBASE_MESSAGING_SENDER_ID');
if (!firebaseConfig.appId) missingConfig.push('REACT_APP_FIREBASE_APP_ID');

if (missingConfig.length > 0) {
  console.error('❌ Missing Firebase environment variables:', missingConfig.join(', '));
  console.error('Please check your .env file and ensure all Firebase configuration variables are set.');
}

// Initialize Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
  console.log('✅ Firebase initialized successfully');
} catch (error) {
  console.error('❌ Firebase initialization error:', error);
  throw new Error('Failed to initialize Firebase. Please check your configuration.');
}

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Storage
export const storage = getStorage(app);

// Initialize Authentication
export const auth = getAuth(app);

// Verify auth is properly configured
if (!auth.app.options.authDomain) {
  console.error('❌ Firebase Authentication domain not configured. Please:');
  console.error('1. Enable Authentication in Firebase Console');
  console.error('2. Enable Email/Password sign-in method');
  console.error('3. Verify REACT_APP_FIREBASE_AUTH_DOMAIN is set correctly');
}

export default app;
